import React, { useMemo } from "react";
import { SelectField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { useCategories } from "../contexts/categories-context";
import { fieldTypes } from "../constants";

const CategoryField = React.memo(() => {
  const taskCategories = useCategories();

  const options = useMemo(() => {
    return Object.values(taskCategories).map((category) => ({
      value: category,
      label: translate(null, "care_team_tasks.categories", category.replace("TASKCATEGORY_", "")),
    }));
  }, [taskCategories]);

  return (
    <SelectField
      name={fieldTypes.CATEGORY}
      options={options}
      className="category-field"
      label={translate(null, "care_team_tasks.form.fields.category", "label")}
      placeholder={translate(null, "care_team_tasks.form.fields.category", "placeholder")}
    />
  );
});

export default CategoryField;
